import networkService from '../Network/NetworkManager';
import APPURL from '../Constants/URLConstants';
import AppConstants from '../Constants/AppConstants';

export const getTenantKeys = async () => {
  const responseJson = await networkService.networkCall(
    `skua/tenants/keys?env=production`,
    'get',
    '',
  );

  return responseJson.data;
};
